import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AttachmentService } from 'src/app/service/attachment.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AttachmentDataSource } from 'src/app/service/attachment.datasource';
import { tap } from 'rxjs/operators';
import { environment, environment_msg } from 'src/environments/environment';
import { NotifierService } from 'angular-notifier';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';

export interface attachmentData {
  sno: string;
  urlname: string;
  edit : string;
  delete: string;
  existing : boolean;
}


const ELEMENT_DATA: attachmentData[] = [
  {sno: '1', urlname: 'Jikan flow.com',edit : 'edit', delete: 'delete_forever',existing : false},
  {sno: '2', urlname: 'Jikan_latest.com',edit : 'edit', delete: 'delete_forever',existing : false},
  {sno: '3', urlname: 'Jikan_Mock.com',edit : 'edit', delete: 'delete_forever',existing : true}
];
@Component({
  selector: 'app-add-link-dialog',
  templateUrl: './add-link-dialog.component.html',
  styleUrls: ['./add-link-dialog.component.css']
})
export class AddLinkDialogComponent implements OnInit {
  displayedColumns = [ "linkURL","edit", "delete"];
  //dataSource!: MatTableDataSource<attachmentData>;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
 // @ViewChild(MatSort)  sort!: MatSort;
  attachmentData : any
  linkDataSource!: AttachmentDataSource;
  listReqJSON:any;
  private readonly notifier!: NotifierService;
  //UI Team varaible declaration for validation
  validate = false
  conAttachmentDel: any;
  responsevalue: any;

  urlRegex = /^https:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  attachmentEditFlag: any;
  disableAttachmentFileIcon: any;


  constructor(private dialogRef: MatDialogRef<AddLinkDialogComponent>,public meetingService:MeetingService,private dialog :MatDialog,public attachService:AttachmentService, @Inject(MAT_DIALOG_DATA) data:any,private attachmentService: AttachmentService,notifierService: NotifierService) {  
    ////consolee.log("inside constructor",data);
    this.attachmentData = data;
    this.notifier = notifierService;
    // this.dataSource = new MatTableDataSource(ELEMENT_DATA);
     this.setData();
     this.listReqJSON =
    {
      "orgCode": "CHN",
      "idisplayStart": 0,
      "idisplayLength": 5,
      "fkEntityId":data.entityId,
      "attachmentEntityType":data.entityType,
      "attachmentMode":"LI"
    }
    
     this.disableAttachmentFileIcon = data.disaleAttachmentFileIcon;
  }

  addLinkBox = new UntypedFormGroup({
    attachmentLink: new UntypedFormControl('',[Validators.required, Validators.pattern(this.urlRegex)]),
    editattachmentLink:new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    entityType: new UntypedFormControl(''),
    attachmentMode:new UntypedFormControl(''),
    meetingId:new UntypedFormControl(''),
    taskId:new UntypedFormControl(''),
    noteId:new UntypedFormControl(''),
    decisionId:new UntypedFormControl(''),
    attachmentId:new UntypedFormControl('')
  });


  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;
    if(!this.attachmentData.data){
      document.getElementById('special')?.setAttribute('disabled','true')
    }
    this.linkDataSource.counter$
    .pipe(
      tap((count) => {
        this.paginator.length = count;
        //this.isLoading = true;
      })
    )
    .subscribe();
  this.paginator.page
    .pipe(
      tap(() => this.loadAttachmentList())
    )
    .subscribe(); 
    

    if(this.attachmentData.disaleAttachmentFileIcon == true){
      this.disableAttachmentFileIcon = this.attachmentData.disaleAttachmentFileIcon;
    }else{
      this.disableAttachmentFileIcon = this.attachmentData.disaleAttachmentFileIcon;
    }
}
loadAttachmentList() {
  this.listReqJSON.idisplayStart=this.paginator.pageIndex;
  this.listReqJSON.idisplayLength=this.paginator.pageSize;
  this.linkDataSource.loadAttachmentList(this.listReqJSON);
}
  
  deleteAttachment(attachmentId:any){
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle : "Confirmation",
        dialogContent : environment_msg.msg_confirm_delete_attachment
      },
    }).afterClosed().subscribe(response => {
      this.conAttachmentDel = response

      if(this.conAttachmentDel){
    this.attachService.deleteAttachment(attachmentId).subscribe(res => {
      if (res != null) {
       
        this.notifier.show({
          type: 'success',
          message: 'Deleted Successfully'
        });
        this.loadAttachmentList();
      }
    });
  }
});
  }

  triggerContentEditable(number : any){

    this.attachmentEditFlag = true;
    const bool = false
    const rowIdentifier = document.getElementById(number);
    if(rowIdentifier != null){      
      // rowIdentifier?.isContentEditable == !bool;
      $(rowIdentifier).attr('contenteditable','true');
      $(rowIdentifier).focus();
      $(rowIdentifier).css("background","rgb(239, 239, 255)");
      $(rowIdentifier).css("outline","none");
      $(rowIdentifier).css("padding-left","5px");
      $(rowIdentifier).css("border-left","2px dotted black");
      $(rowIdentifier).css("border-top","2px dotted black")
      $(rowIdentifier).css("border-bottom","2px dotted black")
      $(rowIdentifier).css("border-right","2px dotted black");
      // $(rowIdentifier).css("box-shadow","0 3px 3px rgba(0,0,0,0.2)")
      // //
    }
  }

  reset(){
    this.addLinkBox.controls['attachmentLink'].setValue('')
  }

  removeContentEditable(number : any){
    const rowIdentifier = document.getElementById(number);
    //
    const url = rowIdentifier ? rowIdentifier.textContent?.trim() : '';
    if(rowIdentifier != null && url && this.urlRegex.test(url)){
      $(rowIdentifier).attr('contenteditable','false');
      $(rowIdentifier).css("background","none");
      $(rowIdentifier).css("outline","none");
      $(rowIdentifier).css("padding-left","0px");
      // $(rowIdentifier).css("box-shadow","none")
      $(rowIdentifier).css("border-top","1px solid rgba(0,0,0,.12)")
      $(rowIdentifier).css("border-bottom","1px solid rgba(0,0,0,.12)")
      $(rowIdentifier).css("border-left","1px solid rgba(0,0,0,.12)");
      $(rowIdentifier).css("border-right","0px solid black");
      // box-shadow: ;

      //this.addLinkBox.controls['attachmentId'].setValue(number);
      const linkField =document.getElementById('attachlink'+number);
      //
      //
      this.addLinkBox.controls['attachmentId'].setValue(number);
      this.addLinkBox.controls['attachmentLink'].setValue(url);
      //
      this.attachmentService.saveLinkURL(this.addLinkBox.value).subscribe(data => {
        var resp = data;
        this.linkDataSource.loadAttachmentList(this.listReqJSON);  
      });
      $('#special').val('')
      this.addLinkBox.reset()
    }
    else if(rowIdentifier!.textContent == ''){
      // window.alert("Required field")
      this.notifier.show({
        type: 'error',
        message: 'Required Field'
      });
    }
    else{
      // window.alert("Invalid URL")
      this.notifier.show({
        type: 'error',
        message: 'Invalid URL'
      });
    }
   
    setTimeout(function(this:any){
      this.linkDataSource.loadAttachmentList(this.listReqJSON);  
    },500);  
  };

  ngOnInit(): void {
    //
    this.linkDataSource = new AttachmentDataSource(this.attachmentService);
    this.listReqJSON.idisplayStart = 0;
    this.listReqJSON.idisplayLength = 5;
    this.listReqJSON.fkEntityId=this.attachmentData.entityId;
    this.listReqJSON.attachmentEntityType=this.attachmentData.entityType;
    this.listReqJSON.attachmentMode=this.attachmentData.attachmentMode;
   let resp = this.linkDataSource.loadAttachmentList(this.listReqJSON);  
  }
  
  setData(){
    switch (this.attachmentData.entityType) {
      case environment.noteEntityType:
        this.addLinkBox.controls['noteId'].setValue(this.attachmentData.entityId);
          break;
      case environment.decisionEntityType:
        this.addLinkBox.controls['decisionId'].setValue(this.attachmentData.entityId);
          break;
      case environment.taskEntityType:
        this.addLinkBox.controls['taskId'].setValue(this.attachmentData.entityId);
          break;
      default:
        this.addLinkBox.controls['agendaId'].setValue(this.attachmentData.entityId);
          break;
    }
    
    this.addLinkBox.controls['attachmentMode'].setValue(this.attachmentData.attachmentMode);
    this.addLinkBox.controls['entityType'].setValue(this.attachmentData.entityType);
    this.addLinkBox.controls['meetingId'].setValue(this.attachmentData.meetingId);
    //this.addLinkBox.controls['attachmentLink'].setValue(this.attachmentLink);
  }

  validURL(str:any) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  saveAttachmentLink(){
    this.setData();
    if(this.attachmentEditFlag != true){
      
    }else{
      this.attachmentEditFlag = false;
    }
    this.addLinkBox.controls['attachmentId'].setValue("");

    if(this.addLinkBox.hasError('required','attachmentLink')){
      // window.alert("called")
      this.validate = true
    }
    else if(this.addLinkBox.hasError('pattern','attachmentLink')){
      this.validate = true
    }
    else{
      this.validate = false;
      var url = this.validURL(this.addLinkBox.value.attachmentLink);
      if(url == true){
      this.attachmentService.saveLinkURL(this.addLinkBox.value).subscribe((data:any) => {
        var resp = data
        this.linkDataSource.loadAttachmentList(this.listReqJSON);
        let special = document.getElementById('special');
      });
    }
  }

    $('#special').val('')
     this.addLinkBox.reset()  
  }
  closeDialog(){
    this.dialogRef.close();
  }
  

}
